// extracted by mini-css-extract-plugin
export var cardHeader = "_f9-0";
export var reorderHandle = "_f9-3";
export var titleArea = "_f9-1";
export var titleAreaWithHandle = "_f9-2";